<div class="ya-typography" (swiperight)="swiperNavigateBack()">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div [@serviceButtonEntering]="isLoaded"
    class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="title-container title-margin">
      <ng-container *ngIf="GroupInfo$ |async; let GroupInfo">
        <h2><span class="title-text-size">{{GetGroupNameText(GroupInfo.groupName)}}</span></h2>
        <h2><span class="title-text-size">{{GetGroupCreatorText(GroupInfo.groupCreator)}}</span></h2>
      </ng-container>
    </div>
    <div class="basket-text-wrap">
      <div class="icon-container">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-gruppenwarenkorb"></div>
      </div>
      <div class="title-container description-margin">
        <p>
          <span langkey="phGroupOrder_Landingpage_BasketTitle"></span>:
        </p>
        <ng-container
          *ngIf="group_basket_count$ |async; let group_basket_count; then filledBasketTemplate else emptyBasketTemplate"></ng-container>
        <ng-template #filledBasketTemplate>
          <p>
            <ng-container *ngIf="group_basket_count$ |async; let group_basket_count">
              <span class="count">{{group_basket_count}}</span>
            </ng-container>
            <span class="middle-text" langkey="phGroupOrder_Landingpage_BasketContent"></span>
            <ng-container *ngIf="group_basket_price$ |async; let group_basket_price">
              <span class="price">{{formatCurrency(group_basket_price)}}</span>
            </ng-container>
          </p>
        </ng-template>
        <ng-template #emptyBasketTemplate>
          <p>
            <span langkey="phGroupOrder_Landingpage_EmptyBasketContent"></span>
          </p>
        </ng-template>
        <div class="basket-text-webshop-button">
          <div class="ya-webshop-button-container animate">
            <ng-container
              *ngIf="group_basket_count$ |async; let group_basket_count then sendGroupOrderActive else sendGroupOrderdisable "></ng-container>
            <ng-template #sendGroupOrderActive>
              <button a11y_Button class="enabled" mat-flat-button (click)="sendGroupOrder()">
                <span [innerHTML]="sendGroupOrderButton"></span>
              </button>
            </ng-template>
            <ng-template #sendGroupOrderdisable>
              <button class="disabled" mat-flat-button disabled>
                <span [innerHTML]="sendGroupOrderButton"></span>
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="groupOrder-service-item-container">
      <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToMenuGroup()">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bestellen"></div>
        </div>
        <div class="content-container">
          <h2 class="title">{{orderButtonTitle}}</h2>
          <span class="text content-container--subfont">{{orderButtonDescription}}</span>
        </div>
      </div>
      <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToGroupOverview()">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-multi"></div>
        </div>
        <div class="content-container">
          <h2 class="title">{{overviewButtonTitle}}</h2>
          <span class="text content-container--subfont">{{overviewButtonDescription}}</span>
        </div>
        <ng-container *ngIf="readyForPickUpCount$ | async; let readyForPickUpCount">
          <div class="mat-badge" [matBadge]="readyForPickUpCount" matBadgeOverlap="false" matBadgeSize="small"
            matBadgePosition="above after">
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="hasPaymentOnServer && orderWithoutPayment;">
        <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToPayment()"
          [ngClass]="(has_open_items$ |async) ? '' : 'disable'">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-bezahlen"></div>
          </div>
          <div class="content-container">
            <h2 class="title">
              {{payButtonTitle}}
            </h2>
            <span class="text content-container--subfont">{{payButtonDescription}}</span>
          </div>
        </div>
      </ng-container>
      <div a11y_Button class="ya-icon-button service-button animate" (click)="navigateToServiceCall()">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-serviceruf"></div>
        </div>
        <div class="content-container">
          <h2 class="title">{{serviceCallButtonTitle}}</h2>
          <span class="text content-container--subfont">{{serviceCallButtonDescription}}</span>
        </div>
      </div>
    </div>
    <div a11y_Button class="ya-webshop-button-container animate" (click)="closeGroupOrderingAsync()">
      <button mat-flat-button>
        <span langkey="phGroupOrder_Landingpage_LeaveGroupOrder_Btn"></span>
      </button>
    </div>
  </div>
</div>